import React, { Component } from "react";
import { I18n } from "react-i18next";
import "../utils/i18n";
import "./KarteResult.css";
import GoogleMapContainer from "../utils/GoogleMapContainer";
import { Marker } from "react-google-maps";
import api from "../api/api";
import { Link } from "react-router-dom";
import { MarkerClusterer } from "react-google-maps/lib/components/addons/MarkerClusterer";
import DetailStandort from "../detail/DetailStandort";

const initialState = {
  detailId: undefined,
  detail: {
    standort: {},
    orgelbauer: {},
    orgel: {}
  }
};

class KarteResult extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;

    this.handleMarkerClick = this.handleMarkerClick.bind(this);
  }

  componentDidMount() {}

  handleMarkerClick(id, recentMassnahmeId) {
    this.setState({ recentMassnahmeId: recentMassnahmeId });
    api.fetchDetails(id).subscribe(result => {
      this.setState({ detail: result });
    });
  }

  render() {
    if (!this.props.searchTerm || !this.props.result) {
      return null;
    }
    return (
      <I18n>
        {(t, { i18n }) => (
          <div className="row">
            <div className="span9">
              <div className="karte-container">
                <GoogleMapContainer
                  googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyAdmbcLZbNjruP22UpYEFrMwJH7-1HVoc0&v=3.exp&libraries=geometry,drawing,places"
                  loadingElement={<div style={{ height: `100%` }} />}
                  containerElement={<div style={{ height: `100%` }} />}
                  mapElement={<div style={{ height: `100%` }} />}
                  center={{ lat: 46.8, lng: 8.2 }}
                  zoom={8}
                  options={{
                    streetViewControl: false,
                    mapTypeControl: true,
                    scrollwheel: false
                  }}
                >
                  <MarkerClusterer
                    averageCenter
                    enableRetinaIcons
                    gridSize={10}
                  >
                    {this.props.result.map(
                      ({ lat, lng, id, recentMassnahmeId }) => (
                        <Marker
                          position={{
                            lat: lat,
                            lng: lng
                          }}
                          key={id}
                          title={id}
                          onClick={this.handleMarkerClick.bind(
                            this,
                            id,
                            recentMassnahmeId
                          )}
                        />
                      )
                    )}
                  </MarkerClusterer>
                </GoogleMapContainer>
              </div>
            </div>
            <div className="span3">
              {this.state.recentMassnahmeId && (
                <div>
                  <DetailStandort
                    standort={this.state.detail.standort}
                    spanSizeTitle="span1"
                    spanSizeText="span2"
                    spanSizeTotal="span3"
                  />
                  <div className="row hslu-link offset2 span1 detailLink">
                    <Link to={`/detail/${this.state.recentMassnahmeId}`}>
                      {i18n.t("navigation.Details")} &raquo;
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </I18n>
    );
  }
}

export default KarteResult;



// WEBPACK FOOTER //
// ./src/search-unified/KarteResult.js